// Matches the viewport inset the live chat dialogs open at (`window.innerWidth - 20`).
const FULLSCREEN_INSET = 20;
const BUTTON_GAP = "8px";
const HEADER_PADDING_BOTTOM = "24px";
const LABEL = "Fullscreen";

const fullscreenSize = () => ({
  width: `${window.innerWidth - FULLSCREEN_INSET}px`,
  maxWidth: `${window.innerWidth - FULLSCREEN_INSET}px`,
  height: `${window.innerHeight - FULLSCREEN_INSET}px`,
  maxHeight: `${window.innerHeight - FULLSCREEN_INSET}px`,
});

let toggleSuppressed = false;

/**
 * Opens a url dialog without a fullscreen toggle, for one that has nothing to grow into -
 * a fixed list to pick from, say.
 *
 * `OpenWindow` fires synchronously inside `openUrl`, so the suppression only ever covers
 * the dialog being opened here.
 */
const openUrlWithoutFullscreenToggle = (editor, config) => {
  toggleSuppressed = true;
  const dialog = editor.windowManager.openUrl(config);
  toggleSuppressed = false;

  return dialog;
};

/**
 * Adds a fullscreen toggle to the header of a url (iframe) dialog.
 *
 * Only url dialogs need it: their body is a fixed-size iframe, so anything opened
 * inside them - a nested editor's own dialogs - is clipped by that viewport instead
 * of growing the dialog. Panel dialogs size themselves and are left alone.
 */
const addDialogFullscreenToggle = editor => {
  if (toggleSuppressed) return;

  const dialogs = document.querySelectorAll(".tox-dialog");
  const dialog = dialogs[dialogs.length - 1];
  const header = dialog?.querySelector(".tox-dialog__header");
  const closeButton = header?.querySelector(".tox-button");

  if (!closeButton || !dialog.querySelector(".tox-dialog__body-iframe")) return;

  const initialSize = {
    width: dialog.style.width,
    maxWidth: dialog.style.maxWidth,
    height: dialog.style.height,
    maxHeight: dialog.style.maxHeight,
  };

  const button = document.createElement("button");
  button.type = "button";
  button.className = closeButton.className;
  button.title = LABEL;
  button.tabIndex = -1;
  button.setAttribute("aria-label", LABEL);
  // The header is `space-between`, so without the auto margin the button lands
  // mid-header instead of next to the close button.
  button.style.marginLeft = "auto";
  button.style.marginRight = BUTTON_GAP;
  button.innerHTML = `<div class="tox-icon">${editor.ui.registry.getAll().icons.fullscreen}</div>`;

  button.addEventListener("click", () => {
    const isFullscreen = dialog.dataset.fullscreen === "true";

    Object.assign(dialog.style, isFullscreen ? initialSize : fullscreenSize());

    if (isFullscreen) delete dialog.dataset.fullscreen;
    else dialog.dataset.fullscreen = "true";
  });

  // The skin leaves the header at `24px 24px 0`, so the buttons sit flush on the body.
  header.style.paddingBottom = HEADER_PADDING_BOTTOM;
  header.insertBefore(button, closeButton);
};

export { addDialogFullscreenToggle, openUrlWithoutFullscreenToggle };
